import React from "react";
import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

// Lazy loading con retry automático
const SelectPlantPage = lazyWithRetry(
  () => import("@features/plantas/ui/pages/SelectPlantPage"),
  "SelectPlantPage",
);
const HerramientasPage = lazyWithRetry(
  () => import("./ui/pages/HerramientasPage"),
  "HerramientasPage",
);
const SelectToolUserPage = lazyWithRetry(
  () => import("./ui/pages/SelectToolUserPage"),
  "SelectToolUserPage",
);
const ToolScanPage = lazyWithRetry(
  () => import("./ui/pages/ToolScanPage"),
  "ToolScanPage",
);

export const TOOLS_ALLOWED_ROLES = [1, 2, 5, 6, 8];
export const TOOLS_SELECTOR_ALLOWED_ROLES = [5, 6];

/**
 * Rutas de herramientas
 */
const toolsRoutes = buildRoutes([
  // Selección de herramientas
  {
    path: "/homegeneral/tools",
    element: SelectToolUserPage,
    roles: TOOLS_SELECTOR_ALLOWED_ROLES,
  },

  // Gestión de herramientas
  {
    path: "/herramientas",
    element: SelectPlantPage,
    roles: TOOLS_ALLOWED_ROLES,
  },
  {
    path: "herramientas/:planta",
    element: HerramientasPage,
    roles: TOOLS_ALLOWED_ROLES,
  },

  // Scanner de herramientas
  {
    path: "/tool-scanner/borrow",
    element: SelectPlantPage,
    roles: TOOLS_ALLOWED_ROLES,
  },
  {
    path: "/tool-scanner/borrow/:planta",
    element: ToolScanPage,
    roles: TOOLS_ALLOWED_ROLES,
  },
]);

export default toolsRoutes;
